import axios from "axios";
import { SESSION_TTL } from "./Utils";

export default async function LoadGeneralData() {
  const ls = require("localstorage-ttl");
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

  const token = JSON.parse(ls.get("jwt"));
  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  axios
    .get(
      `${API_URL}/dojos?populate=*&sort[0]=name%3Aasc&pagination[pageSize]=1000`,
      headerRequest
    )
    .then((res) => ls.set("dojos", JSON.stringify(res.data.data), SESSION_TTL));

  axios
    .get(
      `${API_URL}/grades?sort[0]=id%3Aasc&fields[0]=id&fields[1]=name&fields[2]=rank`,
      headerRequest
    )
    .then((res) =>
      ls.set("grades", JSON.stringify(res.data.data), SESSION_TTL)
    );

  axios
    .get(`${API_URL}/teachers/?populate=*`, headerRequest)
    .then((res) =>
      ls.set("teachers", JSON.stringify(res.data.data), SESSION_TTL)
    );

  axios
    .get(`${API_URL}/config`, headerRequest)
    .then((res) =>
      ls.set("config", JSON.stringify(res.data.data.attributes), SESSION_TTL)
    );
}
